import { g as generatePalette } from "../../chunks/colors-Bws_qBuw.mjs";
function hashCode(str) {
  let hash = 0;
  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
  }
  return Math.abs(hash);
}
function usernameToColor(username) {
  const steps = 6;
  const finalPalette = generatePalette(steps);
  const hash = hashCode(username.toLocaleLowerCase());
  return finalPalette[hash % finalPalette.length];
}
export {
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
